import React, { useCallback } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { NavLink } from "react-router-dom";
import { Cms } from "../routing/routes.js";
import { useDispatch } from "react-redux";
import { closeMenu } from "../sidebar_panel/store.js";
import { jsx as _jsx } from "react/jsx-runtime";
export var MenuLink = function MenuLink(props) {
  var children = props.children,
    activeClassName = props.activeClassName,
    pageName = props.pageName,
    url = props.url;
  var className = classnames("menu-link", props.className);
  var dispatch = useDispatch();
  var computeLinkClass = useCallback(function (_ref) {
    var isActive = _ref.isActive;
    var result = [];
    if (className && className.length > 0) {
      result.push(className);
    }
    if (isActive && activeClassName && activeClassName.length > 0) {
      result.push(activeClassName);
    }
    return result.join(' ');
  }, [activeClassName, className]);
  var onClickHandler = useCallback(function () {
    dispatch(closeMenu());
  }, [dispatch]);
  return pageName ? /*#__PURE__*/_jsx(NavLink, {
    onClick: onClickHandler,
    className: computeLinkClass,
    to: Cms.location({
      pageName: pageName
    }),
    children: children
  }) : /*#__PURE__*/_jsx("a", {
    className: className,
    href: url,
    target: "_blank",
    rel: "noopener noreferrer",
    children: children
  });
};
MenuLink.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  activeClassName: PropTypes.string,
  pageName: PropTypes.string,
  url: PropTypes.string
};